export const IMAGES = {
  adiyogi:
    "https://images.unsplash.com/photo-1609609830354-8f615d61b9c8?crop=entropy&cs=srgb&fm=jpg&q=80&w=640&fit=max",
  shivaOrange:
    "https://images.unsplash.com/photo-1653282767171-c889318ce51c?crop=entropy&cs=srgb&fm=jpg&q=80&w=640&fit=max",
  shivaMeditate:
    "https://images.unsplash.com/photo-1615438890269-65b569062819?crop=entropy&cs=srgb&fm=jpg&q=80&w=640&fit=max",
  shivaSunset:
    "https://images.unsplash.com/photo-1642774667024-e9e2f37914d2?crop=entropy&cs=srgb&fm=jpg&q=80&w=640&fit=max",
  temple:
    "https://images.unsplash.com/photo-1554554497-0095c34db3ec?crop=entropy&cs=srgb&fm=jpg&q=80&w=640&fit=max",
  sagePortrait: "/sage-portrait.webp",
  diyaLamps:
    "https://images.unsplash.com/photo-1741003411334-e6a66b3b78f4?crop=entropy&cs=srgb&fm=jpg&q=80&w=640&fit=max",
  diyaFlame:
    "https://images.unsplash.com/photo-1741003410796-987aea47a48b?crop=entropy&cs=srgb&fm=jpg&q=80&w=640&fit=max",
  diyaWoman:
    "https://images.unsplash.com/photo-1784815130752-60dec0d7a736?crop=entropy&cs=srgb&fm=jpg&q=80&w=640&fit=max",
  zodiacWheel:
    "https://images.unsplash.com/photo-1729335511904-9b8690184935?crop=entropy&cs=srgb&fm=jpg&q=80&w=640&fit=max",
  zodiacDiagram:
    "https://images.unsplash.com/photo-1729335511883-29eade10006b?crop=entropy&cs=srgb&fm=jpg&q=80&w=640&fit=max",
  celestialClock:
    "https://images.unsplash.com/photo-1626245639823-ac58f27ad83c?crop=entropy&cs=srgb&fm=jpg&q=80&w=640&fit=max",
  gemGoldRing:
    "https://images.unsplash.com/photo-1626784214536-d859187e0bd0?crop=entropy&cs=srgb&fm=jpg&q=80&w=640&fit=max",
  gemLoose:
    "https://images.unsplash.com/photo-1597177446764-4bc5e495299e?crop=entropy&cs=srgb&fm=jpg&q=80&w=640&fit=max",
  gemBeads:
    "https://images.unsplash.com/photo-1627234553051-3d60e738b534?crop=entropy&cs=srgb&fm=jpg&q=80&w=640&fit=max",
  gemRing:
    "https://images.unsplash.com/photo-1592317295760-5c1f677dfc78?crop=entropy&cs=srgb&fm=jpg&q=80&w=640&fit=max",
  gemEmerald:
    "https://images.unsplash.com/photo-1600119612651-0db31b3a7baa?crop=entropy&cs=srgb&fm=jpg&q=80&w=640&fit=max",
  gemSapphire:
    "https://images.unsplash.com/photo-1605821771565-35e0d046a2fb?crop=entropy&cs=srgb&fm=jpg&q=80&w=640&fit=max",
  gemRuby:
    "https://images.unsplash.com/photo-1679531751641-79f78cbb5c0b?crop=entropy&cs=srgb&fm=jpg&q=80&w=640&fit=max",
};

export const RASHI_NAMES = [
  "Aries", "Taurus", "Gemini", "Cancer", "Leo", "Virgo",
  "Libra", "Scorpio", "Sagittarius", "Capricorn", "Aquarius", "Pisces",
];

export const PILLARS = [
  {
    title: "Spiritual Precision",
    desc: "Years of disciplined sadhana in Vedic Jyotish and karmic study, refined into razor-sharp insight — not vague comfort.",
  },
  {
    title: "No Sugarcoating",
    desc: "You will not receive half-truths. You receive clarity, direction and the truth your chart has been holding.",
  },
  {
    title: "One Session, Real Shifts",
    desc: "Seekers arrive confused and leave with a plan. This is the hour when life finally starts making sense.",
  },
  {
    title: "Remedies That Rewire Karma",
    desc: "Every remedy is drawn from your own chart — aligned to your planetary blueprint, never generic.",
  },
];

export const LIFE_CATEGORIES = [
  {
    title: "Career",
    questions: [
      "Why does success always feel slow, or just out of reach?",
      "Should you hold your path, switch fields, or begin something new?",
      "What kind of work will truly fulfil you and bring stability?",
    ],
  },
  {
    title: "Love & Relationships",
    questions: [
      "Why do your relationships feel heavy, confusing, or stuck in a loop?",
      "Is your current partner the right one, or a passing season?",
      "What is truly causing the delay in your love life or marriage?",
    ],
  },
  {
    title: "Money & Growth",
    questions: [
      "Why does money arrive but never seem to stay?",
      "Is something quietly blocking your growth and expansion?",
      "What changes can build real, lasting financial stability?",
    ],
  },
  {
    title: "Health & Inner Peace",
    questions: [
      "Why do the same health or energy issues keep returning?",
      "Is stress on the surface, or is something deeper at work?",
      "What is the right time and way to begin healing, inside and out?",
    ],
  },
];

export const CONSULTATION_TYPES = [
  {
    key: "personal",
    name: "Consultation Call",
    desc: "For individuals seeking clarity, direction and precise remedies.",
    togglable: true,
    basePrice: 6500,
    urgentPrice: 15000,
    videoMultiplier: 2,
    includes: [
      "50-minute in-depth chart-based life analysis",
      "Clear direction for Wealth, Career, Relationships, Upcoming Dashas of Enormous growth and rise",
      "Remedies aligned with your planetary blueprint",
    ],
  },
  {
    key: "couple",
    name: "Couple Consultation / Marriage Compatibility",
    desc: "For those navigating relationships, marriage or partnership decisions.",
    togglable: true,
    basePrice: 7500,
    urgentPrice: 15000,
    videoMultiplier: 2,
    includes: [
      "50-minute compatibility and karmic alignment insights",
      "Clarity on love, marriage or partnership challenges",
      "Remedies tailored to both partners' charts",
    ],
  },
  {
    key: "myastrosaathi",
    name: "MyAstroSaathi: Talk with our 24/7 Premium Astrologers",
    desc: "To get truly insightful consultations within 24 hours, we have got you covered — connect with our experienced astrologer.",
    togglable: false,
    href: "https://pages.razorpay.com/pl_TWShJsJZSYDd6V/view",
    details: ["24/7", "Online"],
    includes: [
      "Consult within 24 hours with an experienced astrology expert",
      "Consultation + complementary premium astrology tools for career / relationship",
      "Every chart thoroughly reviewed by MessengerofShiva + expert analysis, then the call is handled to the expert",
      "Post-consultation support with flexible date & time selection",
    ],
  },
  {
    key: "facetoface",
    name: "Face to Face Consultation",
    desc: "Not for everyone. Only for those who truly want answers, direction and powerful results.",
    togglable: false,
    basePrice: 70000,
    details: ["50 Min", "In Person"],
    includes: [
      "Your kundli is checked and explained in front of you",
      "One-on-one spiritual and astrological counsel",
      "Remedies and energy solutions shared instantly",
      "Powerful insights you will not find anywhere else",
    ],
  },
  {
    key: "baby",
    name: "Baby Birth Muhurat Consultation",
    desc: "Choose the most auspicious arrival moment for your child — a lifetime of blessings, planned in the stars.",
    togglable: false,
    basePrice: 15000,
    details: ["50 Min", "Doctor-Aligned"],
    includes: [
      "Highly auspicious birth muhurat options (aligned with doctor-approved window)",
      "Deep planetary analysis for your baby's lifelong growth & protection",
      "1-on-1 consultation with MessengerofShiva",
      "Favorable nakshatra, tithi & planetary combinations selection",
      "Dosha avoidance to ensure a smooth and blessed life path",
      "Guidance on ideal time for strong health, luck & success",
      "Lifetime significance insights of the chosen birth timing",
    ],
  },
];

export const TEAM_ASTROLOGERS = [
  {
    name: "Elite Astrologer Priya Ji",
    tags: "Vedic · KP Astrology · Tarot",
    rating: "4.9",
    sessions: "10,000+ consultations",
    href: "/trusted-astrologer#book",
  },
];

export const FAQS = [
  {
    q: "Will the Messenger personally do the reading?",
    a: "Yes — for the selected consultations, the Messenger personally does the reading. However, in case you selected MyAstroSaathi, our elite experienced astrologer will be assigned for consultation (minimum 15+ years expertise). Every chart is still thoroughly reviewed by MessengerofShiva before your call.",
  },
  {
    q: "Can I ask about multiple topics?",
    a: "Yes, but focus is recommended. This is your time — use it for what matters most.",
  },
  {
    q: "Will I receive remedies during the call?",
    a: "Yes. Remedies are shared live, followed by a written summary after the session.",
  },
  {
    q: "Is my data safe?",
    a: "Completely. Your privacy and chart data are handled with spiritual and ethical responsibility.",
  },
  {
    q: "Can I book this for someone else?",
    a: "Yes, but one chart per session. Please share correct birth details at booking.",
  },
  {
    q: "When will my consultation be scheduled?",
    a: "After booking, your session is scheduled within 7–10 days. Urgent slots are prioritised.",
  },
];

export const TESTIMONIALS = [
  {
    name: "A. Iyer",
    role: "Entrepreneur, Bengaluru",
    text: "Session with Sachin was amazing! I have sat through many consultations, but this felt different — calm, structured, deeply precise. Nothing was exaggerated, and yet some observations were unsettlingly accurate. I left with clarity I had been chasing for years.",
  },
  {
    name: "S. Malhotra",
    role: "Designer, Dubai",
    text: "The name messengerofshiva really resonates with the reading — it felt like divinely guided. The remedies were simple and grounded in my own chart, and within weeks the heaviness I had been carrying started lifting. This is guidance you can actually act on.",
  },
  {
    name: "R. Verma",
    role: "Teacher, Varanasi",
    text: "What stood out was the honesty. No fear-selling, no vague promises — Sachin reads what your soul is trying to tell you and hands you a clear path forward. A thoughtfully guided experience.",
  },
];

export const REPORTS = [
  { title: "Complete Life Kundli", desc: "Your full Vedic birth chart — planets, houses, dashas and a lifetime map of strengths, doshas and remedies.", price: 1100, img: IMAGES.zodiacWheel },
  { title: "Varshphal — Year Ahead", desc: "A month-by-month forecast of your coming year, built on the solar return of your chart.", price: 900, img: IMAGES.shivaOrange },
  { title: "Career Destiny Report", desc: "Which field, which timing, which city. Your 10th house decoded into an actionable career plan.", price: 1500, img: IMAGES.zodiacDiagram },
  { title: "Love & Compatibility Report", desc: "Kundli milan, karmic bonds and what your 5th and 7th houses say about the love you are seeking.", price: 1100, img: IMAGES.diyaFlame },
  { title: "Dhan Yog — Wealth Report", desc: "The wealth combinations hidden in your chart, and the exact windows when they activate.", price: 1500, img: IMAGES.celestialClock },
  { title: "Gemstone Recommendation", desc: "The one stone your chart truly permits — with carat, metal, finger and muhurat for wearing it.", price: 700, img: IMAGES.gemEmerald },
];

export const GEMS = [
  { name: "Ruby — Manik", planet: "Sun", purpose: "Authority, confidence, vitality", img: IMAGES.gemRuby },
  { name: "Pearl — Moti", planet: "Moon", purpose: "Emotional calm, mind peace", img: IMAGES.gemGoldRing },
  { name: "Red Coral — Moonga", planet: "Mars", purpose: "Courage, energy, drive", img: IMAGES.diyaFlame },
  { name: "Emerald — Panna", planet: "Mercury", purpose: "Intellect, speech, business", img: IMAGES.gemEmerald },
  { name: "Yellow Sapphire — Pukhraj", planet: "Jupiter", purpose: "Wisdom, marriage, fortune", img: IMAGES.gemRing },
  { name: "Diamond — Heera", planet: "Venus", purpose: "Luxury, art, relationships", img: IMAGES.gemLoose },
  { name: "Blue Sapphire — Neelam", planet: "Saturn", purpose: "Discipline, wealth, karmic shift", img: IMAGES.gemSapphire },
  { name: "Hessonite — Gomed", planet: "Rahu", purpose: "Shadow work, obsession relief", img: IMAGES.gemBeads },
  { name: "Cat's Eye — Lehsunia", planet: "Ketu", purpose: "Detachment, moksha path", img: IMAGES.gemBeads },
];

export const BLOGS = [
  {
    slug: "shiva-first-yogi",
    title: "Why Shiva Is Called the First Yogi — Adi Guru of the Stars",
    excerpt: "Long before astrology had names for the planets, Mahadev was already teaching how to master them.",
    date: "Feb 2026",
    img: IMAGES.shivaMeditate,
    body: [
      "In the Vedic tradition, astrology was never meant to be a machine of predictions. It was meant to be a mirror — a way for the restless mind to see its own patterns written in the sky. And the one who first taught how to hold that mirror steadily is said to be Shiva himself, the Adi Guru, the first teacher.",
      "The seven great sages received the knowledge of Jyotish from this tradition, and every classical text since begins with an offering to that primordial teacher. This is why a genuine reading does not begin with your planets; it begins with stillness. The astrologer must first become still enough to see clearly.",
      "When you bring your chart to a seeker of Shiva, you are not handed fate. You are handed a map — and reminded that the one who walks it is you. The planets incline; they do not compel. That single sentence is the entire difference between astrology as fear and astrology as freedom.",
      "This is the spirit in which every consultation, gemstone and remedy at Messenger of Shiva is offered: not to bind you to the stars, but to align you with what the stars already know about you.",
    ],
  },
  {
    slug: "shivaratri-veil",
    title: "Maha Shivaratri: The Night the Veil Thins",
    excerpt: "Once a year, the alignment of planets and intention makes remedies on this night uniquely potent.",
    date: "Feb 2026",
    img: IMAGES.shivaSunset,
    body: [
      "Maha Shivaratri is not merely a festival; in Jyotish it is a cosmic alignment. The moon is at its darkest, the mind is naturally quiet, and the ether between worlds is said to be thinnest on this night.",
      "The rishis chose this night for a reason. What you practise here — a mantra, a fast, a single honest resolve — carries the weight of months. It is the most economical night of the year for your karma.",
      "If your chart carries a difficult Saturn, Rahu or Ketu period, this is the night the tradition points to for remedies: abhisheka, the chanting of Om Namah Shivaya, and sitting upright through the four watches of the night if health permits.",
      "You do not need complicated ritual. You need presence. One diya, one mantra, one unwavering hour — and the veil does not feel so thick anymore.",
    ],
  },
  {
    slug: "rudraksha-choosing",
    title: "Rudraksha: Choosing the Bead That Chooses You",
    excerpt: "Not every mukhi is for everyone. Your chart decides which bead belongs to your wrist.",
    date: "Jan 2026",
    img: IMAGES.temple,
    body: [
      "The rudraksha is said to be the tear of Mahadev — compassion that solidified into a seed. Worn correctly, it is not jewellery; it is a standing remedy that works on your aura every hour of the day.",
      "The classical texts assign different mukhis to different planetary lords: the one-mukhi for the Sun's authority, the five-mukhi for Jupiter's wisdom, the seven-mukhi for Saturn's discipline. Wearing the wrong one is like tuning a sitar to the wrong key — harmless, but silent.",
      "This is why we never sell a rudraksha before a reading. Your current dasha, your lagna and the house your ruling planet sits in together decide which bead will actually speak to your life.",
      "Once chosen, it is energised with prana pratishtha and given with one instruction: treat it as a companion, not a charm. The seed holds the memory of the deva; you hold the intention.",
    ],
  },
];

export const CLIENT_FALLBACK = (sign) => ({
  sign,
  finance: 72,
  love: 68,
  health: 75,
  overall: 74,
  luckyNumber: "3, 7",
  luckyColor: "Saffron",
  mood: "Optimistic",
  mantra: "Om Namah Shivaya",
  tip: "Light a diya at dusk and sit with one question, not ten.",
  overview: "Planetary currents favour steady progress. What was stuck begins to loosen by evening.",
});

export const BOOKING_CONTACT = {
  email: "astrologykuber@gmail.com",
  phone: "+91 80000 13966",
  phoneRaw: "+918000013966",
};

export const CONSULTATION_DETAILS = {
  personal: {
    notices: [
      "Your session will be conducted by Sachin Sharma — one of India's most respected Vedic astrologers.",
      "Current Slot Update: Your slot will be booked between 25th October to 15th November 2026. A WhatsApp text will be shared with you regarding the slot timings.",
      "Kindly Note: This consultation is strictly focused on your individual birth chart. Charts of spouse, partner, or family members will not be evaluated within this appointment.",
    ],
    whatYouGet: [
      { title: "Holistic Life Review", desc: "Career, finance, relationships, marriage, health, timing cycles — your major life dimensions are examined with clarity and precision." },
      { title: "Detailed Planetary Breakdown", desc: "Understand the real reasons behind delays, struggles, and sudden shifts — along with powerful Vedic remedies aligned to your chart." },
    ],
  },
  couple: {
    notices: [
      "Your session will be conducted by Sachin Sharma — one of India's most respected Vedic astrologers.",
      "Current Slot Update: Your slot will be booked between 25th October to 15th November 2026. A WhatsApp text will be shared with you regarding the slot timings.",
      "Kindly Note: This session reads both partners' charts together — please keep both birth details (date, time, place) ready when we contact you on WhatsApp.",
    ],
    whatYouGet: [
      { title: "Compatibility & Karmic Alignment", desc: "How the two charts meet — harmony, friction points, emotional wiring and the timing of your union." },
      { title: "Union Remedies & Direction", desc: "Powerful Vedic remedies drawn from both charts, with clear direction for love, marriage and partnership decisions." },
    ],
  },
  facetoface: {
    notices: [
      "Your session will be conducted personally by Sachin Sharma — in person, with your kundli checked and explained in front of you.",
      "Current Slot Update: Your slot will be booked between 25th October to 15th November 2026. A WhatsApp text will be shared with you regarding the slot timings and venue.",
      "Kindly Note: Please arrive 10 minutes early with your exact birth details and your questions written down.",
    ],
    whatYouGet: [
      { title: "Full Chart, Face to Face", desc: "Career, money, marriage, health and timing cycles — your complete kundli decoded in the room, nothing held back." },
      { title: "Instant Remedies & Energy Solutions", desc: "Remedies and energy solutions shared on the spot, aligned to your planetary blueprint for powerful results." },
    ],
  },
  baby: {
    notices: [
      "Your session will be conducted by Sachin Sharma — one of India's most respected Vedic astrologers.",
      "Current Slot Update: Your slot will be booked between 25th October to 15th November 2026. A WhatsApp text will be shared with you regarding the slot timings.",
      "Kindly Note: Muhurats are aligned with the medical window advised by your doctor — the astrology never overrides medical safety.",
    ],
    whatYouGet: [
      { title: "Auspicious Muhurat Options", desc: "Highly auspicious birth timings aligned with your doctor-approved window — favorable nakshatra, tithi and planetary combinations selected." },
      { title: "Lifelong Protection & Growth", desc: "Deep planetary analysis with dosha avoidance — for strong health, luck, success and a smooth, blessed life path, with lifetime significance insights of the chosen timing." },
    ],
  },
};

export const BOOKING_TERMS = [
  "Advance Booking Required: Appointments must be secured prior to the session date.",
  "No Refund After Confirmation: Once payment is completed, it cannot be reversed unless the session is canceled by our team.",
  "Missed Call Policy: If you fail to attend your scheduled session, rescheduling or refund will not be provided.",
  "Rescheduling Rights: MessengerofShiva reserves the right to adjust appointment timings in unforeseen situations.",
  "Technical Responsibility: Clients must ensure stable internet connection and a disturbance-free environment.",
  "Privacy Assurance: All personal and birth details remain strictly confidential.",
  "Time Zone: Calendar operates on IST (Indian Standard Time). Please double-check time conversion before booking.",
  "Recording Restriction: Audio/video recording without prior written permission is prohibited.",
  "Professional Conduct: Mutual respect and discipline are mandatory during the consultation.",
  "Disclaimer: Astrology guidance is for awareness and direction purposes only and should not replace medical, legal, or financial advice.",
  "Payment Terms: Full payment is required to confirm the booking.",
  "Refund Conditions: Refunds are processed only if the session is missed from our side.",
  "Jurisdiction: All disputes are subject to Indian jurisdiction.",
];
